import { createAsyncThunk } from "@reduxjs/toolkit";
//import axios from "axios";
import { userId } from "src/helpers/user_id";
//import { API_URL } from "src/utils/apiConfig";
import { apiClient } from '../../helpers/api_helper';


/*export const getStatusPoints = createAsyncThunk("statusPoints/getStatusPoints", async () => {
    try {
      const response = await apiClient.get(`/project/situations/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);*/

export const addStatusPoints = createAsyncThunk("statusPoints/addStatusPoints", async (statusPoints: any) => {
    try {
      const response = await apiClient.post(`/project/situations/`,{
          mes: statusPoints.mes,
          semana: statusPoints.semana,
          quantidade: statusPoints.quantidade_executada,
          observacao: statusPoints.observacao,
          nivel_execucao: statusPoints.nivel_execucao,
          objectivo: statusPoints.objective_id,
          //TODO pegar o id correcto
          create_user: 1,
          update_user: 1,
        }
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const updateStatusPoints = createAsyncThunk("statusPoints/updateStatusPoints", async (statusPoints: any) => {
    try {
      const response = await apiClient.put(`/project/situations/${statusPoints.id}/`,{
          mes: statusPoints.mes,
          semana: statusPoints.semana,
          quantidade: statusPoints.quantidade_executada,
          observacao: statusPoints.observacao,
          nivel_execucao: statusPoints.nivel_execucao,

          create_user: userId,
          update_user: userId,
        }
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const deleteStatusPoints = createAsyncThunk("statusPoints/deleteStatusPoints", async (statusPointsId: any) => {
    try {
      const response = await apiClient.delete(`/project/situations/${statusPointsId}/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getStatusPointsByObjectiveId = createAsyncThunk("statusPoints/getStatusPointsByObjectiveId", async (objectiveId: any) => {
    try {
      const response = await apiClient.get(
        `/project/project-situations/get-status-points-by-objectives-id/${objectiveId}/`
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);
